import React from 'react';
import { Card, Empty } from 'antd';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { brand } from '@/theme/tokens';
import { ChartSeries } from './LineChartCard';

interface Props {
  title: string;
  data: Array<Record<string, string | number>>;
  xKey: string;
  series: ChartSeries[];
  height?: number;
}

const DEFAULT_COLORS = [brand.primary, brand.commerce, brand.gold, brand.win];

export function BarChartCard({ title, data, xKey, series, height = 240 }: Props): React.ReactElement {
  return (
    <Card title={title} style={{ border: `1px solid ${brand.line}`, borderRadius: 4 }}>
      {data.length === 0 ? (
        <Empty description="Nessun dato nel periodo selezionato" />
      ) : (
        <ResponsiveContainer width="100%" height={height}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke={brand.line} />
            <XAxis dataKey={xKey} tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
            <Tooltip />
            <Legend />
            {series.map((s, i) => (
              <Bar key={s.key} dataKey={s.key} name={s.label} fill={s.color ?? DEFAULT_COLORS[i % DEFAULT_COLORS.length]} />
            ))}
          </BarChart>
        </ResponsiveContainer>
      )}
    </Card>
  );
}
